import React, { useState } from 'react';

import { Sheet, Thumbnail } from '@pkg/components';
import { ReactComponent as PadlockIcon } from '@pkg/components/Sections/Profile/icons/padlock.svg';

import { AssetsImageCacheMaxWidth } from '@app/client/common/structs/assets/assets';
import { type GroupItemNFT } from '@app/client/common/structs/groups/groups';

import { AssetWrapper, DisabledIndicator, Interior, NftAction } from './styles';

export interface NftItemProps {
    item: GroupItemNFT;
    active?: boolean;
    onAction(): void;
}

function assetHasVideo(animationUrl?: GroupItemNFT['animation_url']): animationUrl is string {
    return Boolean(animationUrl?.length);
}

export function NftItem({ item, active = false, onAction }: NftItemProps) {
    const [error, setError] = useState(false);

    const { image, animation_url } = item;
    const hasVideo = assetHasVideo(animation_url);
    const disabled = hasVideo || error;

    // TODO: Should include some kind of a11y label.
    const disabledIndicatorMarkup = disabled ? (
        <DisabledIndicator>
            <PadlockIcon />
        </DisabledIndicator>
    ) : null;

    return (
        <Sheet.Layout.Results.Item>
            <NftAction disabled={disabled} $active={active} onClick={onAction}>
                <Interior>
                    <AssetWrapper>
                        <Thumbnail
                            // title={item.name}
                            imageUrl={image ?? undefined}
                            videoUrl={hasVideo ? animation_url : undefined}
                            mashWidth={AssetsImageCacheMaxWidth.POD_NFT_CARD}
                            onError={() => setError(true)}
                        />
                    </AssetWrapper>

                    {disabledIndicatorMarkup}
                </Interior>
            </NftAction>
        </Sheet.Layout.Results.Item>
    );
}
